import { AccountPermission } from 'modules/permissions/constants';
import { useAcceptToSMutation } from 'domains/userSettings/actions/negativeBalanceTermsOfServices/acceptToS';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useCheckAccountPermission } from 'modules/account/hooks/useCheckAccountPermission';
import { useJWTs } from 'domains/jwtToken/hooks/useJWTs';
import { useToSStatus } from 'domains/userSettings/hooks/useToSStatus';

export const useNegativeBalanceTermsOfServices = () => {
  const { isLoggedIn, isLoggingIn } = useAuth();
  const { group, isAccountInitialized, isFinance } = useAccount();

  const {
    isEnterprise,
    isPremium,
    loaded: accountStatusLoaded,
  } = useAccountStatus();

  const hasGroupAccess = useCheckAccountPermission({
    permission: AccountPermission.TosStatus,
  });

  const { loading: projectsLoading } = useJWTs({
    group,
    skipFetching: true,
  });

  const isPremiumOrFinance = isFinance || isPremium;

  const {
    loading: isToSStatusLoading,
    state: { isSuccess: isTosStatusLoaded },
    tosStatus: { tosAccepted: isToSAccepted },
  } = useToSStatus({
    group,
    skipFetching:
      !isLoggedIn ||
      isLoggingIn ||
      !hasGroupAccess ||
      isEnterprise ||
      !isAccountInitialized ||
      !isPremiumOrFinance ||
      !accountStatusLoaded ||
      projectsLoading,
  });

  const [acceptToS, { isLoading: isAccepting }] = useAcceptToSMutation();

  return {
    acceptToS,
    isAccepting,
    isToSAccepted,
    isToSStatusLoading,
    isTosStatusLoaded,
  };
};
